<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card class="pt-2">
          <template v-slot:headerTitle>
            <h4 class="card-title">
              <i class="fa fa-hand-pointer-o" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
              {{ cvCardTitle }}: <span class="report_name"> {{ action_module_name.module_name }}</span>
            </h4>
            <span>{{getFormattedDate(whereFilter.dateRange.startDate)}}</span> <span> /  {{getFormattedDate(whereFilter.dateRange.endDate)}}</span>
          </template>
          <template v-slot:body>
            <b-row :key="refreshTotalCount">
              <div class="w-100 mb-3 multiple_boxes_row ">
               <div class="ml-2">
                <div class="boxs" :style="'background:'+getBgFor(0)">
                  <iq-card class="btn mb-1 multiCardboxs">
                    <span  class="textintworow text-white">
                      Total
                    </span>
                    <ul>
                      <li class="badge badge-light">Opens<span> {{ total_opens }} </span></li>
                      <li class="badge badge-light">Unique User<span> {{ total_uniqueuser }} </span></li>
                      <li class="badge badge-light">Open per user<span> {{ total_open_per_unique_user }} </span></li>
                    </ul>
                  </iq-card>
                </div>
              </div>
            </div>
            <!-- Date Filter -->
              <b-col col-xs="12" sm="12" md="12" lg="12" xl="12" class="mb-2">
                <div class="dateRange">
                  <date-range-picker ref="picker" :show-dropdowns="true" class="float-right" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange"  @update="getAnalyticsListDateWise()" ></date-range-picker>
                </div>
              </b-col>
              <!-- Date Filter -->
            </b-row>
            <b-row class="mb-3">
              <b-col col-xs="12" sm="6" md="6" lg="3" xl="3" class="mb-2">
                <b-form-input v-model="filter" type="search" :placeholder="cvSearchText"></b-form-input>
              </b-col>
              <b-col col-xs="12" sm="6" md="6" lg="3" xl="3" class="mb-2">
                  <multiselect
                    v-model="action_module_name"
                    :tag-placeholder="cvSelectLabel"
                    :placeholder="cvSelectLabel"
                    :searchable="true"
                    label="module_name"
                    track-by="module_name"
                    :options="clkModuleNameList"
                    @select="setModNameFilterChange"
                    >
                  </multiselect>
              </b-col>
              <b-col col-xs="12" sm="6" md="6" lg="3" xl="3" class="mb-2">
                  <multiselect
                    v-model="action_redirected_url"
                    :tag-placeholder="cvSelectLabel"
                    :placeholder="cvSelectLabel"
                    :searchable="true"
                    label="redirected_to"
                    track-by="redirected_to"
                    :options="clkRedirectedUrlList"
                    @select="setRediretUrlFilterChange"
                    >
                  </multiselect>
              </b-col>
              <b-col col-xs="12" sm="6" md="6" lg="3" xl="3" class="mb-2">
                <select v-model="whereFilter.dateType" class="form-control" @change="setDateTypeFilterChange">
                  <option value="year">Year</option>
                  <option value="month">Month</option>
                  <option value="date">Day</option>
                </select>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="container_minheight" md="12"
                v-if="click_analyticsObjList && click_analyticsObjList.length > 0">
                <b-table
                  hover
                  responsive
                  :items="click_analyticsObjList"
                  :fields="columns"
                  :no-border-collapse="true"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <template v-slot:cell(user_id)="data">
                    {{ data.item.user_name }}
                    <small>{{}}</small>
                  </template>
                </b-table>
              </b-col>
              <b-col class="container_minheight" md="12" v-else>
                No data found
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="7" md="8" class="my-1"></b-col>
              <b-col sm="5" md="4" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"
                  class="my-0"></b-pagination>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal v-model="showModelanalyticsTrackerAdd" scrollable :title="cvAddModalHeader" size="xl">
      <analyticsTrackerAdd :propOpenedInModal="true" @emitCloseanalyticsTrackerAddModal="closeanalyticsTrackerAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="analytics_trackerAdd('FULLPAGE')">
          {{ cvbtnModalExpand }}
        </b-button>
        <b-button size="sm" @click="closeanalyticsTrackerAddModal()">
          {{ cvbtnModalCancel }}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelanalyticsTrackerDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{ cvDelMessage }}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelanalyticsTrackerDelete = false">
          {{ cvbtnModalCancel }}
        </b-button>
        <b-button size="sm" variant="primary" @click="analytics_trackerDelete()">
          {{ cvbtnModalDelOk }}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style lang="scss" scoped>
.multiCardboxs {
  display: table-caption;
  padding: 10px;
  height: auto !important;
  background: transparent !important;
  min-width: 190px;
}
.boxs{
  width: auto;
}
.boxs .badge{
  position: unset;
  min-width: 100%;
  margin-top:10px ;
}
.boxs li{
  font-size: 14px;
  position: relative;
  text-align: left;
}
.boxs span{
  font-size: 13px;
  text-transform: capitalize;
  font-weight: 600;
  float: right;
}
.boxs ul{
  padding: 0px;
  margin-bottom:5px;
}
span.textintworow{
  text-align: center !important;
  font-weight: 900;
  display: block !important;
  margin: auto !important;
  float: unset;
}
.card-title{
  span{
    font-size: 18px;
    font-weight: 500;
  }
}
.dateRange{
  width: 100%;
}
.report_name{
  text-transform: capitalize;
  font-weight: 400;
}
.table{
  display: inline-table !important;;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { socialvue } from "../../../../config/pluginInit.js"
import { clkEngineTrackers } from "../../../../FackApi/api/analytics/click_anallytics"
import ColorCodes from "../../../../Utils/colorcodes.js"
import Multiselect from "vue-multiselect"
import moment from "moment"
import userPermission from "../../../../Utils/user_permission"

export default {
  name: "analyticsTrackerList",
  components: {
    Multiselect
  },
  data () {
    return {
      apiName: "clk_engine_tracker_list",
      cvSelectLabel: "Select ",
      cvCardTitle: "Click Analytics Report",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit clkEngineTrackers",
      cvAddModalHeader: "Add clkEngineTrackers",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Analytics Tracker List Response",
      showModelanalyticsTrackerAdd: false,
      showModelanalyticsTrackerDelete: false,
      sortBy: "name",
      sortDesc: false,
      whereFilter: {
        dateRange: {
          startDate: new Date(new Date().setDate(new Date().getDate() - 30)), // From Last Month
          endDate: new Date(new Date().setDate(new Date().getDate()))
        },
        dateType: "month",
        action: "gpaths",
        redirected_url: null
      },
      columns: [
        { label: "User", key: "user_id", class: "text-left align-text-top", sortable: true },
        { label: "Module Name", key: "module_name", class: "text-left align-text-top", sortable: true },
        { label: "Module Id", key: "module_id", class: "text-left align-text-top", sortable: true },
        { label: "Redirected URL", key: "redirected_to", class: "text-left align-text-top", sortable: true }
      ],
      click_analyticsObjList: null,
      click_analuticsEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      total_open_count_list: {},
      uniqueuser: {},
      totalhit: {},
      total_opens: 0,
      total_uniqueuser: 0,
      option: "",
      clkModuleNameList: [],
      clkRedirectedUrlList: [],
      total_open_per_unique_user: 0,
      action_module_name: { module_name: "gpaths" },
      action_redirected_url: { redirected_to: "c.gide.ai" },
      refreshTotalCount: 0,
      delObj: null
    }
  },
  computed: {
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    },
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.getDateFilter()
    await this.getDataFilters()
    this.analytics_tracker_totalopencount()
    this.click_analytics_list()
  },
  methods: {
    /**
     * getBgFor
     */
    getBgFor (index) {
      return ColorCodes.getBgColor(index)
    },
    /**
     * Get daterange from LS. If found then use this as default else use the onse set in the data section of the object
     */
    async getDateFilter () {
      let storeDate = await this.dateFilter
      if (storeDate && storeDate.dateRange) {
        this.whereFilter.dateRange = storeDate.dateRange
      }
    },
    /**
     * getDataFilters
     */
    async getDataFilters () {
      let clickAnalyticsListResp = await clkEngineTrackers.clk_engine_trackerList(this)
      if (clickAnalyticsListResp.resp_status) {
        let clkAnalyticsObjList = clickAnalyticsListResp.resp_data.data

        // setting module_name filters
        this.clkModuleNameList = Array.from(new Set(clkAnalyticsObjList.map(obj => obj.module_name)))
        this.clkModuleNameList = this.clkModuleNameList.map(modName => { return { module_name: modName } })

        // setting redirected url filter
        this.clkRedirectedUrlList = Array.from(new Set(clkAnalyticsObjList.map(obj => obj.redirected_to)))
        this.clkRedirectedUrlList = this.clkRedirectedUrlList.map(redirectUrl => { return { redirected_to: redirectUrl } })
      }
      else {
        this.toastMsg = clickAnalyticsListResp.resp_msg
        this.toastVariant = "danger"
        this.showToast = true
      }
    },
    /**
     * getFormattedDate
     */
    getFormattedDate (date) {
      try {
        return moment(date).format("DD-MMM-YYYY")
      }
      catch (err) {
        console.log("Exception occurred at getFormattedDate() and Exception:", err.message)
      }
    },
    /**
     * Setting Date Range in the LS
     */
    async setDateFilter () {
      let endDate = this.whereFilter.dateRange.endDate
      this.whereFilter.dateRange.endDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      let whereDateFilter = { dateRange: this.whereFilter.dateRange }
      await this.$store.commit("DateFilter/addSelectedDate", whereDateFilter)
    },
    /**
     * Calling Function as per whereFilter
     */
    async getAnalyticsListDateWise () {
      this.setDateFilter()
      this.analytics_tracker_totalopencount()
      this.click_analytics_list()
    },
    setDateTypeFilterChange (datetype) {
      this.whereFilter.datetype = datetype
      this.analytics_tracker_totalopencount()
      this.click_analytics_list()
    },
    setModNameFilterChange (action) {
      this.whereFilter.action = action.module_name
      this.analytics_tracker_totalopencount()
      this.click_analytics_list()
    },
    setRediretUrlFilterChange (action) {
      this.whereFilter.redirected_url = action.redirected_to
      this.analytics_tracker_totalopencount()
      this.click_analytics_list()
    },
    /**
     * click_analytics_list
     */
    async click_analytics_list () {
      try {
        let clickAnalyticsListResp = await clkEngineTrackers.clk_engine_trackerList(this, this.whereFilter)
        if (clickAnalyticsListResp.resp_status) {
          this.click_analyticsObjList = clickAnalyticsListResp.resp_data.data
          this.totalRows = clickAnalyticsListResp.resp_data.count
        }
        else {
          this.toastMsg = clickAnalyticsListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at click_analytics_list() and Exception:", err.message)
      }
    },

    /**
     * analytics_tracker_totalopencount
     */
    async analytics_tracker_totalopencount () {
      try {
        let analyticsTrackerListTotalopencountResp = await clkEngineTrackers.analytics_tracker_totalopencount(this, this.whereFilter)
        if (analyticsTrackerListTotalopencountResp.resp_status) {
          this.total_open_count_list = analyticsTrackerListTotalopencountResp.resp_data.data
          this.total_opens = 0
          this.total_uniqueuser = 0
          for (let open of this.total_open_count_list) {
            this.total_opens += open.total_open_count
            this.total_uniqueuser += open.unique_user
          }
          this.total_open_per_unique_user = (this.total_uniqueuser == 0) ? "0" : Math.round(this.total_opens / this.total_uniqueuser)
          this.refreshTotalCount += 1
        }
        else {
          this.toastMsg = analyticsTrackerListTotalopencountResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at analytics_tracker_totalopencount() and Exception:", err.message)
      }
    },
    /**
     * analytics_trackerAdd
     */
    analytics_trackerAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/analytics_tracker_add")
        }
        else {
          this.showModelanalyticsTrackerAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at analytics_trackerAdd() and Exception:", err.message)
      }
    },
    /**
     * showanalyticsTrackerDeleteDialog
     */
    showanalyticsTrackerDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelanalyticsTrackerDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showanalyticsTrackerDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * closeanalyticsTrackerAddModal
     */
    closeanalyticsTrackerAddModal (analyticsTrackerAddData) {
      try {
        if (analyticsTrackerAddData) {
          if (this.click_analyticsObjList && this.click_analyticsObjList.length >= 1) {
            let usrlObjLength = this.click_analyticsObjList.length
            let lastId = this.click_analyticsObjList[usrlObjLength - 1]["id"]
            analyticsTrackerAddData.id = lastId + 1
          }
          else {
            this.click_analyticsObjList = []
            analyticsTrackerAddData.id = 11111
          }

          analyticsTrackerAddData.created_on = moment()
          this.click_analyticsObjList.unshift(analyticsTrackerAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelanalyticsTrackerAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeanalytics_trackerAddModal() and Exception:", err.message)
      }
    }
  }
}
</script>
